import { connect } from 'react-redux';
import ForgotLinkPage from './ForgotLinkPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
// import { push } from 'react-router-redux';
import {
    saveUsername, doForgotLink, getForgotLinkPage,
} from '../../actions/forgotLinkAction';
import { handleCloseAlert } from 'src/actions/errorAction';

export const mapStateToProps = (state: AppState) => {
    return {
        btnElement: 'Sign-in to Troubleshoot',
        btnType: 'signin',
        userName: state.forgotLink.userName,
        errorMessage: state.errorState.errorMessage,
        errorBar: state.errorState.errorBar,
        successMessage: state.errorState.successMessage,
        successBar: state.errorState.successBar
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onSubmit: () => {
            // dispatch(fetchCurrentUser);
            dispatch(doForgotLink);
        },
        saveUsername: (username: string) => {
            dispatch(saveUsername(username));
        },
        handleClose: () => {
            dispatch(handleCloseAlert);
        },
        onComponentDidMount: () => {
            // dispatch(initiateLogin);
            dispatch(getForgotLinkPage);
        }
    };
};

const ForgotLinkPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ForgotLinkPage);

export default ForgotLinkPageContainer;



// WEBPACK FOOTER //
// ./src/components/forgotPasswordLinkPage/ForgotLinkPageContainer.tsx